module.exports = __webpack_public_path__ + "img/appstore@2x.48056d90.png";